import { Splide } from '../../index.js';

document.addEventListener('DOMContentLoaded', () => {
  const elem = document.querySelector('.slider-hero-v1 .splide');
  if (!elem) return;

  const splide = new Splide(elem, {
    type: 'loop',
    speed: 1800,
    autoplay: true,
    interval: 5000,
    pauseOnHover: true,
    pauseOnFocus: true,
    arrows: true,
    pagination: true,
    perPage: 1,
    gap: 0,
    heightRatio: 0.5,

    breakpoints: {
      1024: {
        pagination: true,
      },
      768: {
        pagination: true,
      },
    },
  });

  // Monta lo slider
  splide.mount();
});
